import { createActionCreator } from 'deox';
import { Organisation, Paging, Invitations } from '@/types';
import { OrganisationForm } from '@/services/api-portal';

export const updateOrganisationActions = {
  request: createActionCreator(
    'UPDATE_ORGANISATION_REQUEST',
    (resolve) => (
      organisationId: string,
      organisation: OrganisationForm,
      isActive: boolean,
      newOrganisation?: boolean,
    ) => resolve({ organisationId, organisation, isActive, newOrganisation }),
  ),
  success: createActionCreator('UPDATE_ORGANISATION_SUCCESS'),
  failure: createActionCreator('UPDATE_ORGANISATION_FAILURE', (resolve) => (error: unknown) =>
    resolve({ error }),
  ),
};

export const createOrganisationActions = {
  request: createActionCreator(
    'CREATE_ORGANISATION_REQUEST',
    (resolve) => (organisation: OrganisationForm) => resolve({ organisation }),
  ),
  success: createActionCreator('CREATE_ORGANISATION_SUCCESS'),
  failure: createActionCreator('CREATE_ORGANISATION_FAILURE', (resolve) => (error: unknown) =>
    resolve({ error }),
  ),
};

export const fetchOrganisationActions = {
  request: createActionCreator(
    'FETCH_ORGANISATION_REQUEST',
    (resolve) => (organisationId: string) => resolve({ organisationId }),
  ),
  success: createActionCreator(
    'FETCH_ORGANISATION_SUCCESS',
    (resolve) => (organisation: Organisation) => resolve({ organisation }),
  ),
  failure: createActionCreator('FETCH_ORGANISATION_FAILURE', (resolve) => (error: unknown) =>
    resolve({ error }),
  ),
};

export const fetchOrganisationApiKeyActions = {
  request: createActionCreator(
    'FETCH_ORGANISATION_APIKEY_REQUEST',
    (resolve) => (organisationId: string) => resolve({ organisationId }),
  ),
  success: createActionCreator('FETCH_ORGANISATION_APIKEY_SUCCESS', (resolve) => (apiKey: string) =>
    resolve({ apiKey }),
  ),
  failure: createActionCreator('FETCH_ORGANISATION_APIKEY_FAILURE', (resolve) => (error: unknown) =>
    resolve({ error }),
  ),
};

export const fetchOrganizationInvitationActions = {
  request: createActionCreator(
    'FETCH_ORGANIZATION_INVITATION_REQUEST',
    (resolve) => (invitationCode: string) => resolve({ invitationCode }),
  ),
  success: createActionCreator(
    'FETCH_ORGANIZATION_INVITATION_SUCCESS',
    (resolve) => (organisation: Organisation) => resolve({ organisation }),
  ),
  failure: createActionCreator(
    'FETCH_ORGANIZATION_INVITATION_FAILURE',
    (resolve) => (error: unknown) => resolve({ error }),
  ),
};

export const toggleEntityEnabledActions = {
  request: createActionCreator(
    'TOGGLE_ENTITY_ENABLED_REQUEST',
    (resolve) => (entityId: string, isActive: boolean) => resolve({ entityId, isActive }),
  ),
  success: createActionCreator(
    'TOGGLE_ENTITY_ENABLED_SUCCESS',
    (resolve) => (entityId: string, isActive: boolean) => resolve({ entityId, isActive }),
  ),
  failure: createActionCreator('TOGGLE_ENTITY_ENABLED_FAILURE', (resolve) => (error: unknown) =>
    resolve({ error }),
  ),
};

export const inviteUserToOrganizationActions = {
  request: createActionCreator(
    'INVITE_USER_TO_ORGANIZATION_REQUEST',
    (resolve) => (email: string, orgDomain, memberships) =>
      resolve({ email, orgDomain, memberships }),
  ),
  success: createActionCreator(
    'INVITE_USER_TO_ORGANIZATION_SUCCESS',
    (resolve) => (email: string) => resolve({ email }),
  ),
  failure: createActionCreator(
    'INVITE_USER_TO_ORGANIZATION_FAILURE',
    (resolve) => (error: unknown) => resolve({ error }),
  ),
};

export const fetchInvitationsActions = {
  request: createActionCreator('FETCH_INVITATIONS_REQUEST'),
  success: createActionCreator(
    'FETCH_INVITATIONS_SUCCESS',
    (resolve) => (data: Invitations[], paging: Paging) => resolve({ data, paging }),
  ),
  failure: createActionCreator('FETCH_INVITATIONS_FAILURE', (resolve) => (error: unknown) =>
    resolve({ error }),
  ),
};
